import { useQuery } from '@tanstack/react-query';
import { useProjectsContext } from 'src/modules/projects/context';

import { mapTierDTOToTier } from '../infra/mappers';
import { tiersService } from '../infra/tiersService';

export const tiersQueryKeys = {
  all: (projectId: string) => ['tiers', projectId] as const,
};

export function useTiersQuery() {
  const { project } = useProjectsContext();
  const projectId = project?.id;

  return useQuery({
    queryKey: tiersQueryKeys.all(projectId ?? ''),
    queryFn: async () => {
      const response = await tiersService.list(projectId as string);
      return response.tiers.map(mapTierDTOToTier);
    },
    enabled: !!projectId,
  });
}
